import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { useUser } from "@clerk/clerk-react";
import { SignIn } from "@clerk/clerk-react";
import "react-phone-number-input/style.css";

export default function Auth() {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const { isSignedIn, isLoaded } = useUser();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      setLocation("/orders/new");
    }
  }, [isLoaded, isSignedIn, setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardHeader>
          <h1 className="text-2xl font-bold text-center">{t("pages.auth.loginPortal")}</h1>
          <p className="text-center text-muted-foreground">
            {t("pages.auth.signInToYour")}
          </p>
        </CardHeader>
        <CardContent>
          <SignIn
            routing="virtual"
            signUpUrl="/setup"
            afterSignInUrl="/orders/new"
            appearance={{
              elements: {
                formButtonPrimary:
                  "bg-primary hover:bg-primary/90 text-primary-foreground",
                card: "shadow-none",
                headerTitle: "hidden",
                headerSubtitle: "hidden",
                formFieldLabel: "text-sm font-medium",
                formFieldInput:
                  "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
              },
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
